import PropTypes from 'prop-types';
import { BsPlus } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';
import ProgressBar from '#globalComponents/ProgressBar/ProgressBar';
import { formatCount, formatEuro } from '#lib/numberFormat';

const SEAT_PRICE_EUR = 5;

const getTone = (usedSeats, totalSeats) => {
	if (usedSeats > totalSeats) return 'warning';
	if (usedSeats === totalSeats) return 'caution';
	return 'primary';
};

export const SeatCounter = ({ usedSeats, totalSeats, isOwner = false, onAddSeat, isAddingSeat = false }) => {
	const isFull = usedSeats >= totalSeats;

	return (
		<Card>
			<div className="mb-3 flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
				<h3 className="whitespace-nowrap text-sm font-semibold text-text">Team-Plätze</h3>
				<span className="whitespace-nowrap text-sm text-bgBase-800">
					{formatCount(usedSeats)} / {formatCount(totalSeats)} belegt
				</span>
			</div>
			<ProgressBar value={usedSeats} max={totalSeats} tone={getTone(usedSeats, totalSeats)} />
			{isFull && isOwner && (
				<div className="mt-3 space-y-1.5">
					<Button size="sm" onClick={onAddSeat} loading={isAddingSeat}>
						<BsPlus className="h-4 w-4" />
						Platz kaufen ({formatEuro(SEAT_PRICE_EUR)}/Monat)
					</Button>
					<p className="text-xs text-bgBase-800">
						Der Betrag wird anteilig auf Ihrer nächsten Rechnung berechnet.
					</p>
				</div>
			)}
			{isFull && !isOwner && (
				<p className="mt-3 text-xs text-caution-700">
					Alle Plätze belegt. Bitte wenden Sie sich an Ihren Team-Owner, um weitere Plätze hinzuzufügen.
				</p>
			)}
		</Card>
	);
};

SeatCounter.propTypes = {
	usedSeats: PropTypes.number.isRequired,
	totalSeats: PropTypes.number.isRequired,
	isOwner: PropTypes.bool,
	onAddSeat: PropTypes.func,
	isAddingSeat: PropTypes.bool,
};
